<template lang="pug">
div.footer-nav
  div.help-button(v-if="useHelpButton" @click="goHelp")
    img(src="@/assets/img/icon-hint.png")
    span ヘルプ
  div.brand
    img(src="@/assets/img/logo.png")
</template>

<script>
export default {
  props: {
    useHelpButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goHelp() {
      this.$router.push("/help");
    }
  }
};
</script>

<style lang="sass" scoped>
.footer-nav
  margin-top: auto

.help-button
  align-items: center
  display: inline-flex
  margin: 2.1vh 6.4vw
  span
    margin-left: 2.7vw
  img
    width:  4.5vmax

.brand
  background: none
  height: auto
  img
    margin: 1.5vh 0
    padding-left: calc(50% - 8.55vmax)
    width: 17.1vmax
</style>
